import { IAutoFill } from './AutoFill'

export type IFormField =
  | ITextField
  | ITextareaField
  | IEmailField
  | INumberField
  | ICheckboxField
  | IRadioButtonsField
  | ISelectField
  | IHtmlTextField
  | IHiddenField
  | ITelephoneField

interface IBaseField {
  id: string
  required?: boolean
  autoFill?: IAutoFill
}

export enum FieldType {
  TEXT = 'text',
  PHONE = 'telephone',
  TEXT_AREA = 'textArea',
  EMAIL = 'email',
  NUMBER = 'number',
  HIDDEN = 'hidden',
  CHECKBOX = 'checkbox',
  RADIO_BUTTONS = 'radioButtons',
  SELECT = 'select',
  HTML_TEXT = 'htmltext',
}

export interface ITextField extends IBaseField {
  type: 'text'
  label?: string
  placeholder?: string
  maxLength?: number
}

export const isTextField = (field: IFormField): field is ITextField => {
  return field.type === FieldType.TEXT
}

export interface ITelephoneField extends IBaseField {
  type: FieldType.PHONE
  label?: string
  placeholder?: string
}

export interface ITextareaField extends IBaseField {
  type: 'textArea'
  label?: string
  placeholder?: string
  maxLength?: number
}

export const isTextareaField = (field: IFormField): field is ITextareaField => {
  return field.type === FieldType.TEXT_AREA
}

export interface IEmailField extends IBaseField {
  type: 'email'
  label?: string
  placeholder?: string
  maxLength?: number
  forceBusinessEmail?: boolean
}

export const isEmailField = (field: IFormField): field is IEmailField => {
  return field.type === FieldType.EMAIL
}

export interface INumberField extends IBaseField {
  type: 'number'
  label?: string
  placeholder?: string
  min?: number
  max?: number
  prefix?: string
}

export const isNumberField = (field: IFormField): field is INumberField => {
  return field.type === FieldType.NUMBER
}

export interface IHiddenField extends IBaseField {
  type: 'hidden'
}

export const isHiddenField = (field: IFormField): field is IHiddenField => {
  return field.type === FieldType.HIDDEN
}

export interface ICheckboxField extends IBaseField {
  type: 'checkbox'
  label: string
}

export const isCheckboxField = (field: IFormField): field is ICheckboxField => {
  return field.type === FieldType.CHECKBOX
}

export interface IRadioButtonsField extends IBaseField {
  type: 'radioButtons'
  label?: string
  values: IFieldValue[]
}

export const isRadioButtonsField = (field: IFormField): field is IRadioButtonsField => {
  return field.type === FieldType.RADIO_BUTTONS
}

export interface ISelectField extends IBaseField {
  type: 'select'
  values: IFieldValue[]
  label?: string
  placeholder?: string
}

export const isSelectField = (field: IFormField): field is ISelectField => {
  return field.type === FieldType.SELECT
}

export interface IHtmlTextField extends IBaseField {
  type: 'htmltext'
  text: string
}

export const isHtmlTextField = (field: IFormField): field is IHtmlTextField => {
  return field.type === FieldType.HTML_TEXT
}

export interface IFieldValue {
  label: string
  value: string
}
